import { useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import {
    useHistory,
    useParams
} from "react-router-dom";
import Field from "./Field";
import { firestore } from "./firebase";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import queryString from "query-string";
import { toast } from "react-toastify";


export default function Suggestion() {
    const history = useHistory();
    const location = useLocation();

    const [queryParams, setQueryParams] = useState({});
    useEffect(() => setQueryParams(queryString.parse(location.search)), [location.search]);

    const { id } = useParams();

    const [data, setData] = useState({});
    const [suggestion, setSuggestion] = useState(null);

    const [unsavedChanges, setUnsavedChanges] = useState(false);

    useEffect(() => JSON.stringify(data) !== JSON.stringify(suggestion?.data()) ? setUnsavedChanges(true) : setUnsavedChanges(false), [data, suggestion]);

    useEffect(() => firestore.collection('suggestions').doc(id).get().then(document => {
        setData(document.data());
        setSuggestion(document);
    }), [id]);

    const back = () => {
        if(!queryParams.return) return false;
        history.push(queryParams.return);
        return true;
    }

    const remove = async () => {
        if(!window.confirm('Bist du dir sicher, dass du diesen Eintrag löschen willst?')) return;
        await firestore.collection('suggestions').doc(id).delete();
        toast.success("Löschen erfolgreich", {theme: "dark"})
        if(!back())
            history.push('/suggestions');
    }

    return <div>
        <Prompt message="Einige Änderungen wurden noch nicht gespeichert. Trotzdem fortfahren?" when={unsavedChanges} />
        <div className="bg-gray-500 flex flex-col md:flex-row gap-2 p-4 md:py-0 md:px-2">
            {queryParams.return && <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={back}>Zurück</button>}
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={remove}>Vorschlag löschen</button>
            <div className="bg-gray-500 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold hidden md:block text-gray-500">a</div>
        </div>
        {
            id && suggestion ? <div className="p-3" key={suggestion.id}>
                <Field name="ID" value={suggestion.id} type="constant" />
                <Field name="Name" value={suggestion.data().name} type="constant" />
                <Field name="Quelle" value={suggestion.data().location} type='constant' />
                <Field name="Weitere Informationen" value={suggestion.data().description} type='constant' />
            </div> : <div className="p-3">
                Bitte warten...
            </div>
        }
    </div>;
}

// function getSubject(data) {
//     if (data.event != null) return 'event';
//     if (data.organizer != null) return 'organizer';
//     if (data.user != null) return 'user';
// }

// function getSubjectId(data) {
//     if (data.event != null) return data.event;
//     if (data.organizer != null) return data.organizer;
//     if (data.user != null) return data.user;
// }